module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-bin@2x-9f093232692721a4a265bf8429a6f7e2.png";